<template>
  <router-link
    :to="`/${month}/live/${program.id}`"
    class="program-wrapper current"
  >
    <div class="program" @click="$store.state.scrollYatTop=scrollY">
      <figure class="program-thumbnail">
        <div class="thumbnail">
          <img
            :src="program.imageUrl"
            :alt="title"
          >
        </div>
      </figure>
      <div class="program-detail">
        <!-- ステータスラベル -->
          <!-- <div
            class="time"
            :class="{
              'program-onair': status === 'doing',
              'program-end': status === 'done'
            }"
          >
            <template v-if="status === 'doing'">
              LIVE配信中
            </template>
            <template v-else-if="status === 'will'">
              {{ startAtFormatted }}配信
            </template>
            <template v-else>
              終了
            </template>
          </div> -->
          <!-- <div
            v-if="liveType === program.ｍissedUrl"
            class="archive"
            :class="{
              'program-onair': status === 'doing',
              'program-now': status === 'will'
            }"
          >
            <template v-if="status === 'done'">
              アーカイブあり
            </template>
          </div> -->
          <div class="program-title">
            <h2>{{ title }}</h2>
            <p v-if="getChannelType==='isOnlyCompany' || getChannelType==='isOnlyTsuruha'">
              {{ program.exhibitorName }}
            </p>
            <p v-else>
              {{ program.eventName }}
            </p>
          </div>
        </div>
      </div>
      <div class="keyword" v-if="getChannelType==='isOnlyCompany'">
      <PresentIcon />
    </div>
  </router-link>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import PresentIcon from '@/components/atoms/PresentIcon.vue'
export default {
  props: {
    program: {
      type: Object,
      required: true
    },
    liveType: {
      type: String,
      required: true
    },
    month: {
      type: String,
      required: true
    }
  },
  components: {
    PresentIcon
  },
  data: () => ({
    table1002: {
      '10:00': 1,
      '10:10': 2,
      '11:00': 3,
      '11:50': 4,
      '12:40': 5,
      '13:30': 6,
      '14:20': 7,
      '15:10': 8,
      '15:50': 9
    },
    table1003: {
      '10:00': 10,
      '10:10': 11,
      '11:00': 12,
      '11:50': 13,
      '12:40': 14,
      '13:30': 15,
      '14:20': 16,
      '15:10': 17,
      '15:50': 18
    },
    status: 'will',
    startAt: '',
    endAt: '',
    scrollY: 0
  }),
  computed: {
    ...mapState([
      'selectTime',
      'dateTab',
      'lastSelectedDateTab'
    ]),
    title () {
      return this.liveType === 'company' || this.program.isTsuruhaChannel ? this.program.eventname : this.program.title
    },
    replaceTime () {
      let frames = []
      switch (this.selectTime) {
        case '10:00':
          frames = [1, 10]
          break
        case '10:10':
          frames = [2, 11]
          break
        case '11:00':
          frames = [3, 12]
          break
        case '11:50':
          frames = [4, 13]
          break
        case '12:40':
          frames = [5, 14]
          break
        case '13:30':
          frames = [6, 15]
          break
        case '14:20':
          frames = [7, 16]
          break
        case '15:10':
          frames = [8, 17]
          break
        case '15:50':
          frames = [9, 18]
          break
        default:
          frames = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]
      }
      return frames
    },
    table () {
      return this.lastSelectedDateTab === '2020-10-02' ? this.table1002 : this.table1003
    },
    invertTable () {
      return _.invert(this.table)
    },
    keysTable () {
      return _.keys(this.invertTable)
    },
    dayFrame () {
      const intersect = _.intersection(this.program.deliveryFrame, this.keysTable.map(Number))
      if (intersect.length === 0) {
        if (this.lastSelectedDateTab === '2020-10-02') {
          const keysTable = _.keys(_.invert(this.table1003))
          return _.intersection(this.program.deliveryFrame, keysTable.map(Number))
        } else {
          const keysTable = _.keys(_.invert(this.table1002))
          return _.intersection(this.program.deliveryFrame, keysTable.map(Number))
        }
      }
      return _.intersection(this.program.deliveryFrame, this.keysTable.map(Number))
    },
    current () {
      // 選択した時刻に表示させるかどうか
      let addFrame = []
      let newArray = []
      let pullOtherDateFrame = []
      if (this.lastSelectedDateTab === '2020-10-03') {
        pullOtherDateFrame = _.pullAll(this.replaceTime, [10, 11, 12, 13, 14, 15, 16, 17, 18])
      } else {
        pullOtherDateFrame = _.pullAll(this.replaceTime, [1, 2, 3, 4, 5, 6, 7, 8, 9])
      }
      if (this.selectTime !== 'すべて') {
        if (this.program.deliveryTime < 6) {
          return _.intersection(pullOtherDateFrame, this.program.deliveryFrame).length
        } else {
          addFrame = this.program.deliveryFrame.map((frame) => {
            return String(Number(frame) + 1)
          })
          newArray = this.program.deliveryFrame.concat(addFrame)
          return _.intersection(pullOtherDateFrame, newArray).length
        }
      } else {
        return true
      }
    },
    now () {
      return this.$moment()
    },
    len () {
      let time = ''
      switch (this.program.deliveryTime) {
        case '1':
          time = 10
          break
        case '2':
          time = 15
          break
        case '3':
          time = 20
          break
        case '4':
          time = 25
          break
        case '5':
          time = 30
          break
        case '6':
          time = 40
          break
        case '7':
          time = 60
          break
      }
      return time
    },
    firstFrame () {
      if (this.invertTable[this.dayFrame[0]] === undefined) {
        if (this.lastSelectedDateTab === '2020-10-02') {
          const table = _.invert(this.table1003)
          return table[this.dayFrame[0]]
        } else {
          const table = _.invert(this.table1002)
          return table[this.dayFrame[0]]
        }
      }
      return this.invertTable[this.dayFrame[0]]
    },
    lastFrame () {
      return this.invertTable[this.dayFrame[this.dayFrame.length - 1]]
    },
    startAtFormatted () {
      return this.$moment(this.startAt).format('H:mm')
    },
    getChannelType () {
      if (this.liveType === 'provider') {
        return 'isOnlyProvider'
      } else if (this.liveType === 'company') {
        return 'isOnlyCompany'
      }
      return 'isOnlyTsuruha'
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.setCurrentProgram()
  },
  watch: {
    selectTime: {
      handler (val, old) {
        this.setCurrentProgram()
      }
    }
  },
  methods: {
    setCurrentProgram () {
      if (this.selectTime !== 'すべて') {
        if (this.program.deliveryTime) {
          // 30分までのプログラムはそのまま
          this.startAt = this.lastSelectedDateTab + ' ' + this.selectTime
        } else {
          if (_.indexOf(this.program.deliveryFrame, this.table[this.selectTime]) > -1) {
            // 自身のframe開始時間が一致
            this.startAt = this.lastSelectedDateTab + ' ' + this.selectTime
          } else {
            // 自身のframe開始時間が一致しない
            const idx = this.table[this.selectTime]
            this.startAt = this.lastSelectedDateTab + ' ' + this.invertTable[idx - 1]
          }
        }
      } else {
        if (this.now.isBefore('2020-10-02', 'day')) {
          this.startAt = this.lastSelectedDateTab + ' ' + this.firstFrame
        } else if (this.now.isAfter('2020-10-03', 'day')) {
          this.status = 'done'
          this.startAt = this.lastSelectedDateTab + ' ' + this.lastFrame
        } else {
          this.nextAndNow()
        }
      }
      this.endAt = this.$moment(this.startAt).add(this.len, 'minutes')
    },
    nextAndNow () {
      if (this.now.isSame('2020-10-02', 'day')) {
        if (this.lastSelectedDateTab === '2020-10-02') {
          this.calcNextAndNow()
        } else {
          this.status = 'will'
          this.startAt = this.lastSelectedDateTab + ' ' + this.firstFrame
          this.endAt = this.$moment(this.startAt).add(this.len, 'minutes')
        }
      } else {
        if (this.lastSelectedDateTab === '2020-10-02') {
          this.status = 'done'
          this.startAt = this.lastSelectedDateTab + ' ' + this.lastFrame
          this.endAt = this.$moment(this.startAt).add(this.len, 'minutes')
        } else {
          this.calcNextAndNow()
        }
      }
    },
    calcNextAndNow () {
      let isBetween = false
      const isBefore = []
      this.dayFrame.forEach((frame) => {
        const start = this.lastSelectedDateTab + ' ' + this.invertTable[frame]
        const end = this.$moment(start).add(this.len, 'minutes')
        if (this.now.isBetween(start, end, 'minute', '[]')) {
          this.startAt = start
          this.endAt = end
          this.status = 'doing'
          isBetween = true
        } else if (this.now.isBefore(start)) {
          isBefore.push(start)
        }
      })
      if (!isBetween) {
        if (isBefore.length > 0) {
          this.status = 'will'
          this.startAt = isBefore[0]
          this.endAt = this.$moment(isBefore[0]).add(this.len, 'minutes')
        } else {
          this.status = 'done'
        }
      }
    },
    handleScroll () {
      this.scrollY = window.scrollY
    }
  }
}
</script>

<style lang="sass" scoped>
.program-wrapper
  color: $black
  margin-top: 20px
  position: relative
  &.current
    display: block
  &:not(.current)
    display: none
.program
  background-color: #fff
  border-radius: 8px
  overflow: hidden
  box-shadow: 0 2px 8px rgba(0, 0, 0, .2)
  .program-thumbnail
    position: relative
    .thumbnail
      display: flex
      justify-content: center
      align-items: center
      overflow: hidden
      position: relative
      @media only screen and (max-width: 600px)
        height: calc((50vw - 30px)/2)
      @media only screen and (min-width: 601px)
        height: 135px
      img
        max-width: 100%
        position: absolute
        top: 0
        bottom: 0
        left: 0
        right: 0
        margin: auto
  .program-detail
    padding: 10px
    .time
      text-align: center
      color: #fff
      background-color: $green
      padding: 4px 10px
      border-radius: 20px
      font-size: 1.2rem
      margin-bottom: 5px
      max-width: 105px
      &.program-onair
        background-color: $poppink
      &.program-end
        background-color: $gray
    .archive
      color: #fff
      padding: 4px 10px
      border-radius: 20px
      font-size: 1.2rem
      background-color: $poppink
      margin-bottom: 5px
      max-width: 105px
      &.program-onair
        background-color: initial
      &.program-now
        background-color: initial
    .archive:empty
      display: none
    h2
      line-height: 1.6
      font-size: 1.2rem
    p
      color: $gray
      line-height: 1.6
      font-size: 1rem
.keyword
  width: 32px
  height: 32px
  position: absolute
  top: -6px
  right: -6px
</style>
